import { render, staticRenderFns } from "./TeachRoomSiZheng.vue?vue&type=template&id=2024c6c2&scoped=true&"
import script from "./TeachRoomSiZheng.vue?vue&type=script&lang=js&"
export * from "./TeachRoomSiZheng.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomSiZheng.vue?vue&type=style&index=0&id=2024c6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024c6c2",
  null
  
)

export default component.exports